import { useState } from "react";
import AdminConfigurationDetails from "./AdminConfigurationDetails";
import PlanSetup from "./PlanSetup";

const AdminConfiguration = () => {
  const [open, setOpen] = useState<boolean>(false);
  const handleClick = (): void => {
      setOpen(true);
  };  
  return (
    <div className="content-wrapper">
      <h1 className="flex align-items-center">
        Admin Configuration
      </h1>
      <PlanSetup handleClick={handleClick}/>
      {open && 
        <AdminConfigurationDetails />
      }      
    </div>    
  );
};

export default AdminConfiguration;
